<mat-expansion-panel class="address-expansion" [expanded]="expandPanel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ addressForm.get('address')?.value || 'No address line is registered' }}</mat-panel-title>
    <button
      *ngIf="addressForm.get('address')?.value && !readOnly"
      mat-icon-button
      matTooltip="Delete address"
      color="warn"
      (click)="$event.stopPropagation(); deleteAddress()"
    >
      <mat-icon>remove_circle_outline</mat-icon>
    </button>
  </mat-expansion-panel-header>
  <form class="address-form-container" [formGroup]="addressForm">
    <div class="address-form-row">
      <mat-form-field appearance="outline">
        <mat-label>Address</mat-label>
        <input matInput placeholder="Search address" formControlName="address" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectAddress($event.option.value)">
          <mat-option *ngIf="isSearching" disabled>
            <mat-spinner diameter="20"></mat-spinner>
            Searching...
          </mat-option>
          <ng-container *ngIf="!isSearching">
            <mat-option *ngFor="let address of results" [value]="address" [matTooltip]="address?.formattedAddress">
              {{ address?.countryFlag }} {{ address?.formattedAddress || 'Unknown address' }}
            </mat-option>
            <mat-option *ngIf="results?.length === 0" disabled> No addresses found </mat-option>
          </ng-container>
        </mat-autocomplete>
        <mat-hint>Start typing to search for addresses</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Address</mat-label>
        <input matInput placeholder="Address2" formControlName="address2" />
        <mat-error *ngIf="addressForm.get('address2').hasError('correction')"> C/O, Apt, Suite, Unit are <strong>required</strong> </mat-error>
        <mat-hint>Please fill address2 (optional)</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <input matInput placeholder="City" formControlName="city" />
        <mat-hint>Please fill city</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>County</mat-label>
        <input matInput placeholder="County" formControlName="county" />
        <mat-hint>Please fill county</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-select formControlName="state">
          <mat-option *ngFor="let state of states" [value]="state.abbreviation">
            {{ state.name }} ({{ state.abbreviation }})
          </mat-option>
        </mat-select>
        <mat-hint>Please select state</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Postal Code</mat-label>
        <input matInput placeholder="Zip code" formControlName="postalCode" />
        <mat-hint>Please fill Zip code</mat-hint>
      </mat-form-field>
    </div>
    <div *ngIf="correctionMessage" class="correction-message-container">
      <mat-icon>lightbulb_2</mat-icon>
      <p class="correction-message">{{ correctionMessage }}</p>
    </div>
    <div class="address-form-row">
      <mat-checkbox formControlName="primary">Select as primary address</mat-checkbox>
    </div>
  </form>
  <div class="address-form-row save-button">
    <button mat-raised-button [disabled]="loading" color="default" type="button" (click)="onValidateAddress()">
      Validate Address
      <mat-icon color="accent" *ngIf="addressValidated$ | async" matSuffix>check_circle</mat-icon>
    </button>
    <button
      mat-raised-button
      [disabled]="addressForm.invalid || (this.addressValidated$ | async) === false"
      (click)="saveAddress()"
      color="primary"
    >
      {{ saveLabel }}
    </button>
  </div>
</mat-expansion-panel>
